/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default theme => ({
    requeststatus:{
        height: 'fit-content',
        '& .title':{
          fontSize: pxToEm(32),
          fontWeight: 'bold',
          marginBottom: pxToEm(10)
        },
        '& p': {
            fontSize: pxToEm(24),
            lineHeight: '1.3',
            marginBottom: pxToEm(25)
        },
        '& ul':{
            listStyleType: 'none',
            marginBottom: pxToEm(40),
            paddingLeft: 0,
            '& li':{
                display: 'flex',
                justifyContent: 'space-between',
                fontSize: pxToEm(14),
                lineHeight: '1.2',
                marginBottom: pxToEm(15),
                fontWeight: 'normal',
                maxWidth: '72%',
                '& .icon':{
                    fontSize: pxToEm(24),
                    marginRight: pxToEm(20)
                },
                '&.norequestlistitem':{
                    marginTop: pxToEm(23)
                }
            },
            '& .subtitle':{
                maxWidth: '100%',
                fontSize: pxToEm(24),
                margin: `${pxToEm(10)} 0`
            }
        },
        '& button':{
            marginTop: pxToEm(10),
            width: 'fit-content'
        },
        '& .name-check-circle':{
            color: theme.color.secondary.medium.swatch,
            fontSize: pxToEm(50)
        }
    }
});
